// extracted by mini-css-extract-plugin
export default {"UriMetric":"jtAbjUkly9zKIgzq8aBh"};